export default __webpack_public_path__ + "static/media/heart.1b53b8d5.svg";